<template>
  <div>
    <el-form :model="sampleInfo" ref="sampleInfoForm" :rules="rules" label-width="140px" size="small">
      <el-card shadow="never" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>委托方信息</span>
        </div>
        <div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="委托单位名称：" prop="entName">
                {{sampleInfo.entName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮政编码：" prop="entPost">
                {{sampleInfo.entPost}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="委托单位地址：" prop="entAddress">
                {{sampleInfo.entAddress}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="委托人签名：" prop="entSignName">
                {{sampleInfo.entSignName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联络人：" prop="entContact">
                <el-select v-model="sampleInfo.entContact" @change="selContact">
                  <el-option v-for="item in contacts" :key="item.id" :label="item.name"
                             :value="item.id"></el-option>
                </el-select>
                <el-button style="margin-left: 5px;" type="primary" size="small" @click="handleAddContact">添加联络人</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话号码：" prop="entPhone">
                {{sampleInfo.entPhone}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="电子邮箱：" prop="entEmail">
                {{sampleInfo.entEmail}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产单位名称：" prop="proPost">
                <el-select v-model="sampleInfo.proName" @change="selManufacturer">
                  <el-option v-for="item in manufacturers" :key="item.id" :label="item.manufacturer"
                          :value="item.id"></el-option>
                </el-select>
                <el-button style="margin-left: 5px;" type="primary" size="small" @click="handleAddMaunct">新增生产单位</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮政编码：" prop="proPost">
                {{sampleInfo.proPost}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="生产单位地址：" prop="proAddress">
                {{sampleInfo.proAddress}}
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <el-card shadow="never" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>样品信息</span>
        </div>
        <div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="样品名称：" prop="sampleName">
                <el-input v-model="sampleInfo.sampleName" placeholder="请输入样品名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商标：" prop="sampleLogo">
                <el-input v-model="sampleInfo.sampleLogo" placeholder="请输入商标"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="规格型号：" prop="sampleModel">
                <el-input v-model="sampleInfo.sampleModel" placeholder="请输入规格型号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产日期或批号：" prop="sampleDate">
                <el-input v-model="sampleInfo.sampleDate" placeholder="请输入生产日期或批号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="样品数量：" prop="sampleNum">
                  <el-input-number v-model="sampleInfo.sampleNum" :min="1"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="样品性状：" prop="sampleCharacter">
                <el-input v-model="sampleInfo.sampleCharacter" placeholder="请输入样品性状"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="包装情况：" prop="samplePackage">
                <el-radio-group v-model="sampleInfo.samplePackage">
                  <el-radio  v-for="item in selectOptions.packageOptions" :label="item.code" :key="item.code">{{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="包装方式：" prop="packageType">
                <el-radio-group v-model="sampleInfo.packageType">
                  <el-radio  v-for="item in selectOptions.packageTypeOptions" :label="item.code" :key="item.code">{{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="送样方式：" prop="sampleSend">
                <el-radio-group v-model="sampleInfo.sampleSend">
                  <el-radio  v-for="item in selectOptions.sendOptions" :label="item.code" :key="item.code">{{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="保存条件：" prop="sampleSave">
                <el-radio-group v-model="sampleInfo.sampleSave">
                  <el-radio  v-for="item in selectOptions.saveOptions" :label="item.code" :key="item.code">{{item.name}}</el-radio>
                </el-radio-group>
                <el-input style="width: 200px;margin-left: 10px;" v-model="sampleInfo.sampleSaveOther"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="检验类别：" prop="sampleCheckType">
                <el-radio-group v-model="sampleInfo.sampleCheckType">
                  <el-radio  v-for="item in selectOptions.checkOptions" :label="item.code" :key="item.code">{{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col v-if="sampleInfo.sampleDescript" :span="24">
              <el-form-item label="送样说明：">
                <span style="color: red;font-weight: 500">{{sampleInfo.sampleDescript}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="委托书备注：" >
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  placeholder="请输入委托单备注"
                  maxlength="40"
                  show-word-limit
                  v-model="sampleInfo.orderRemark">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <el-card shadow="never" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>委托方声明</span>
        </div>
        <div>
          <el-form-item label="" prop="checked" label-width="0">
              <el-checkbox v-model="sampleInfo.checked"><b>我方保证对所提供的一切资料、信息及样品的真实性负责。</b></el-checkbox>
          </el-form-item>
        </div>
      </el-card>
    </el-form>
    <el-divider></el-divider>
    <div class="clearfix" style="text-align: center">
      <el-button size="medium" type="warning" @click="handleBack">返回上一页</el-button>
      <el-button size="medium" type="warning" :loading="loading" @click="handleSavePause">暂存</el-button>
      <el-button size="medium" type="success" :loading="loading" @click="handleSaveNext">提交检验委托书</el-button>
    </div>
    <!-- 生产单位 -->
    <el-dialog :title="title" :visible.sync="manufactFormVisible" v-if="manufactFormVisible" :destroy-on-close="true"
               width="70%" @click="closeDialog" center
               :close-on-click-modal="false"
               :close-on-press-escape="false" append-to-body>
      <manufacture-edit ref="manufactDialog" :edit="manufactForm"></manufacture-edit>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" class="title" @click="handleSaveMaunct">保存</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>

    <!-- 联络人 -->
    <el-dialog title="添加联络人" :visible.sync="contactFormVisible" v-if="contactFormVisible" :destroy-on-close="true"
               width="50%" @click="closeDialog" center
               :close-on-click-modal="false"
               :close-on-press-escape="false" append-to-body>
      <contactEdit ref="contactDialog" :edit="contactForm"></contactEdit>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" class="title" @click="handleSaveContact">保存</el-button>
        <el-button @click="contactFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLists, save } from '@/api/user/manufacture'
import { getLists as getListsContact, save as saveContact } from '@/api/user/userContact'
import { submitTestEntrustForm, getTestEntrustResponse } from '@/api/test/entrust'
import ManufactureEdit from './edit/manufactureEdit'
import contactEdit from './edit/contactEdit'
export default {
  name: 'sample-info',
  components: { ManufactureEdit, contactEdit },
  props: {
    entrustId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      checked: true,
      pause: false,
      manufactFormVisible: false,
      contactFormVisible: false,
      manufactForm: {},
      contactForm: {},
      manufacturers: [],
      contacts: [],
      selectOptions: {
        packageOptions: [],
        packageTypeOptions: [],
        sendOptions: [],
        saveOptions: [],
        checkOptions: []
      },
      sampleInfo: {
        orderRemark: '',
        entSignName: '',
        sampleDescript: '',
        entrustId: '',
        entId: '',
        entContact: '',
        entPhone: '',
        entEmail: '',
        entName: '',
        entPost: '',
        entAddress: '',
        proId: '',
        proName: '',
        proPost: '',
        proAddress: '',
        sampleCharacter: '',
        sampleCheckType: '',
        sampleDate: '',
        sampleLogo: '',
        sampleModel: '',
        sampleName: '',
        sampleNum: 2,
        samplePackage: '',
        packageType: '',
        sampleSave: '',
        sampleSaveOther: '',
        sampleSend: '',
        checked: true
      },
      rules: {
        sampleName: [
          { required: true, message: '请输入样品名称', trigger: 'blur' }
        ],
        sampleLogo: [
          { required: true, message: '请输入商标', trigger: 'blur' }
        ],
        sampleModel: [
          { required: true, message: '请输入规格型号', trigger: 'blur' }
        ],
        sampleDate: [
          { required: true, message: '请输入生产日期或批号', trigger: 'blur' }
        ],
        sampleNum: [
          { required: true, message: '请输入样品数量', trigger: 'blur' }
        ],
        sampleCharacter: [
          { required: true, message: '请输入样品性状', trigger: 'change' }
        ],
        samplePackage: [
          { required: true, message: '请选择包装情况', trigger: 'change' }
        ],
        packageType: [
          { required: true, message: '请选择包装情况', trigger: 'change' }
        ],
        sampleSend: [
          { required: true, message: '请选择送样方式', trigger: 'change' }
        ],
        sampleSave: [
          { required: true, message: '请选择保存条件', trigger: 'change' }
        ],
        sampleCheckType: [
          { required: true, message: '请选择检验类别', trigger: 'change' }
        ],
        checked: [
          { required: true, message: '请勾选法律声明', trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    // 初始化选项
    this.selectOptions.packageOptions = this.commonUtils.getDictPara('sample_package')
    this.selectOptions.packageTypeOptions = this.commonUtils.getDictPara('package_type')
    this.selectOptions.sendOptions = this.commonUtils.getDictPara('sample_send')
    this.selectOptions.saveOptions = this.commonUtils.getDictPara('sample_save')
    this.selectOptions.checkOptions = this.commonUtils.getDictPara('sample_check_type')
    this.getCompanyAllManufacturers()
    if (this.entrustId) {
      this.sampleInfo.entrustId = this.entrustId
      this.getTestEntrustResponse()
    } else {
      this.getContactAll()
    }
  },
  computed: {
    companyInfo () {
      return this.$store.state.user.companyInfo
    },
    userInfo () {
      return this.$store.state.user.userInfo
    },
    isLogin () {
      return this.$store.state.user.isLogin
    }
  },
  methods: {
    getTestEntrustResponse () {
      let param = { entrustId: this.entrustId }
      getTestEntrustResponse(param).then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          if (result.bizData.sampleDescript) {
            this.sampleInfo.sampleDescript = result.bizData.sampleDescript
          }
          if (result.bizData.testEntrust) {
            // 样品信息
            this.sampleInfo.orderRemark = result.bizData.testEntrust.orderRemark
            this.sampleInfo.sampleCharacter = result.bizData.testEntrust.sampleCharacter
            this.sampleInfo.sampleCheckType = result.bizData.testEntrust.sampleCheckType
            this.sampleInfo.sampleDate = result.bizData.testEntrust.sampleDate
            this.sampleInfo.sampleLogo = result.bizData.testEntrust.sampleLogo
            this.sampleInfo.sampleModel = result.bizData.testEntrust.sampleModel
            this.sampleInfo.sampleName = result.bizData.testEntrust.sampleName
            this.sampleInfo.handelPart = result.bizData.testEntrust.handelPart
            if (result.bizData.testEntrust.sampleNum) {
              this.sampleInfo.sampleNum = result.bizData.testEntrust.sampleNum
            }
            if (result.bizData.testEntrust.samplePackage) {
              this.sampleInfo.samplePackage = result.bizData.testEntrust.samplePackage
            } else {
              if (this.selectOptions.packageOptions.length > 0) {
                this.sampleInfo.samplePackage = this.selectOptions.packageOptions[0].code
              }
            }
            if (result.bizData.testEntrust.packageType) {
              this.sampleInfo.packageType = result.bizData.testEntrust.packageType
            } else {
              if (this.selectOptions.packageTypeOptions.length > 0) {
                this.sampleInfo.packageType = this.selectOptions.packageTypeOptions[0].code
              }
            }
            if (result.bizData.testEntrust.sampleSave) {
              this.sampleInfo.sampleSave = result.bizData.testEntrust.sampleSave
            } else {
              if (this.selectOptions.saveOptions.length > 0) {
                this.sampleInfo.sampleSave = this.selectOptions.saveOptions[0].code
              }
            }
            if (result.bizData.testEntrust.sampleSaveOther) {
              this.sampleInfo.sampleSaveOther = result.bizData.testEntrust.sampleSaveOther
            }
            if (result.bizData.testEntrust.sampleSend) {
              this.sampleInfo.sampleSend = result.bizData.testEntrust.sampleSend
            } else {
              if (this.selectOptions.sendOptions.length > 0) {
                this.sampleInfo.sampleSend = this.selectOptions.sendOptions[0].code
              }
            }
            if (result.bizData.testEntrust.sampleCheckType) {
              this.sampleInfo.sampleCheckType = result.bizData.testEntrust.sampleCheckType
            } else {
              if (this.selectOptions.checkOptions.length > 0) {
                this.sampleInfo.sampleCheckType = this.selectOptions.checkOptions[0].code
              }
            }
          }
          if (result.bizData.testEntrustEnt) {
            // this.sampleInfo = result.bizData.testEntrustEnt
            // 委托单位信息
            this.sampleInfo.id = result.bizData.testEntrustEnt.id
            this.sampleInfo.entId = result.bizData.testEntrustEnt.entId
            this.sampleInfo.entContact = result.bizData.testEntrustEnt.entContact
            this.sampleInfo.entPhone = result.bizData.testEntrustEnt.entPhone
            this.sampleInfo.entEmail = result.bizData.testEntrustEnt.entEmail
            this.sampleInfo.entName = result.bizData.testEntrustEnt.entName
            this.sampleInfo.entPost = result.bizData.testEntrustEnt.entPost
            this.sampleInfo.entAddress = result.bizData.testEntrustEnt.entAddress
            this.sampleInfo.entSignName = result.bizData.testEntrustEnt.entSignName
            // 生产单位信息
            this.sampleInfo.proId = result.bizData.testEntrustEnt.proId
            this.sampleInfo.proName = result.bizData.testEntrustEnt.proName
            this.sampleInfo.proPost = result.bizData.testEntrustEnt.proPost
            this.sampleInfo.proAddress = result.bizData.testEntrustEnt.proAddress
            if (!this.sampleInfo.entSignName) {
              this.sampleInfo.entSignName = this.userInfo.name
            }
          } else {
            if (this.companyInfo) {
              this.sampleInfo.entId = this.userInfo.companyId
              this.sampleInfo.entName = this.companyInfo.companyName
              this.sampleInfo.entPost = this.companyInfo.postCode
              this.sampleInfo.entAddress = this.companyInfo.companyAddress
              this.sampleInfo.entSignName = this.userInfo.name
            }
          }
          this.getContactAll()
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.$message.error('加载失败')
      })
    },
    getCompanyAllManufacturers: function () {
      getLists().then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          result.bizData.unshift({ id: '', manufacturer: '无', proPost: '', proAddress: '' })
          this.manufacturers = result.bizData
          if (!this.sampleInfo.proId && this.manufacturers && this.manufacturers.length > 0) {
            this.selManufacturer(this.manufacturers[0].id)
          }
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.$message.error('加载生产单位失败')
      })
    },
    getContactAll: function () {
      getListsContact().then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          this.contacts = result.bizData
          if (!this.sampleInfo.entContact && this.contacts.length > 0) {
            this.sampleInfo.entContact = this.contacts[0].name
            this.sampleInfo.entPhone = this.contacts[0].mobile
            this.sampleInfo.entEmail = this.contacts[0].mailBox
          }
          // 添加默认值
          if (!this.sampleInfo.entContact && this.userInfo) {
            this.sampleInfo.entContact = this.userInfo.name
            this.sampleInfo.entPhone = this.userInfo.mobile
            this.sampleInfo.entEmail = this.userInfo.mailBox
          }
        } else {
          // 添加默认值
          if (!this.sampleInfo.entContact && this.userInfo) {
            this.sampleInfo.entContact = this.userInfo.name
            this.sampleInfo.entPhone = this.userInfo.mobile
            this.sampleInfo.entEmail = this.userInfo.mailBox
          }
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        // 添加默认值
        if (!this.sampleInfo.entContact && this.userInfo) {
          this.sampleInfo.entContact = this.userInfo.name
          this.sampleInfo.entPhone = this.userInfo.mobile
          this.sampleInfo.entEmail = this.userInfo.mailBox
        }
        this.$message.error('加载联系人失败')
      })
    },
    handleBack () {
      this.$emit('back')
    },
    handleSaveNext () {
      this.handleSave('next')
    },
    handleSavePause () {
      this.pause = true
      this.handleSave('pause')
    },
    handleSave (type) {
      if (type === 'next') {
        if (!this.sampleInfo.checked) {
          this.$message.warning('请选择委托方声明!')
          return
        }
        if (!this.sampleInfo.entName) {
          this.$message.warning('请完善公司信息再下单!')
          return
        }
        this.sampleInfo.handelPart = '2'
      } else {
        this.sampleInfo.handelPart = '1'
      }
      this.$refs['sampleInfoForm'].validate(valid => {
        if (valid || type === 'pause') {
          this.loading = true
          submitTestEntrustForm(this.sampleInfo)
            .then(res => {
              this.loading = false
              var result = res.data
              if (result.rtnCode !== '0') {
                this.$message({
                  type: 'info',
                  message: result.msg
                })
              } else {
                if (type === 'pause') {
                  this.$router.push({
                    path: 'userCenter/myEntrust?st=1'
                  })
                } else {
                  this.$emit('next')
                }
              }
            }).catch(ex => {
              this.loading = false
              this.$message.error('列表加载失败，请稍后再试！')
            })
        }
      })
    },
    selManufacturer (id) {
      let item = this.manufacturers.filter(item => {
        return item.id === id
      })
      this.sampleInfo.proId = item[0].id
      this.sampleInfo.proAddress = item[0].address
      this.sampleInfo.proName = item[0].manufacturer
      this.sampleInfo.proPost = item[0].postCode
    },
    selContact (id) {
      let item = this.contacts.filter(item => {
        return item.id === id
      })
      this.sampleInfo.entContact = item[0].name
      this.sampleInfo.entPhone = item[0].mobile
      this.sampleInfo.entEmail = item[0].mailBox
    },
    // 新增
    handleAddMaunct () {
      this.title = '新增生产单位'
      this.manufactForm = {}
      this.manufactForm.pageType = 'add'
      this.manufactForm.isDefault = 1
      this.manufactFormVisible = true
    },
    // 新增联络人
    handleAddContact () {
      this.contactForm = {}
      this.contactForm.pageType = 'add'
      this.contactForm.isDef = 1
      this.contactFormVisible = true
    },
    // 保存
    handleSaveMaunct () {
      if (this.isDisabled) {
        return false
      }
      this.isDisabled = true
      const formBody = this.$refs['manufactDialog'].editForm
      formBody.companyId = this.userInfo.companyId
      this.$refs['manufactDialog'].$refs['editForm'].validate(valid => {
        if (valid) {
          if (formBody.pageType === 'add') {
            save(formBody).then(response => {
              this.isDisabled = false
              const result = response.data
              if (result.rtnCode === '0') {
                this.manufactFormVisible = false
                this.getCompanyAllManufacturers()
              } else {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: '新增生产单位失败，' + result.msg
                })
              }
            }).catch(ex => {
              this.isDisabled = false
              this.loading = false
              this.$message('新增生产单位失败，请稍后再试！')
            })
          }
        } else {
          this.isDisabled = false
          return false
        }
      })
    },
    // 保存
    handleSaveContact () {
      if (this.isDisabled) {
        return false
      }
      this.isDisabled = true
      const formBody = this.$refs['contactDialog'].editForm
      this.$refs['contactDialog'].$refs['editForm'].validate(valid => {
        if (valid) {
          if (formBody.pageType === 'add') {
            saveContact(formBody).then(response => {
              this.isDisabled = false
              const result = response.data
              if (result.rtnCode === '0') {
                this.contactFormVisible = false
                this.getContactAll()
              } else {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: '新增联系人失败，' + result.msg
                })
              }
            }).catch(ex => {
              this.isDisabled = false
              this.loading = false
              this.$message('新增联系人失败，请稍后再试！')
            })
          }
        } else {
          this.isDisabled = false
          return false
        }
      })
    },
    closeDialog () {
      this.manufactFormVisible = false
    }
  }
}
</script>

<style scoped>

</style>
